import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import { get } from "lodash";

import { fetchPost } from "../../../api/fetch";

import { setBreadcrumb } from "../../../actions/common";

import Box from "@material-ui/core/Box";

import MdcInventoryForm from "./MdcInventoryForm";
import MdcInventoryData from "./MdcInventoryData";

import { computePeriod } from "../../../utils/date";

const styles = {
  container: {
    width: "100%",
    maxHeight: "calc(100vh - 100px)",
    overflow: "auto",
  },
  gridLine1: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 12px",
  },
  gridLine2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(638px, 1fr))",
    gridAutoRows: "460px",
    gridGap: "24px",
    padding: "12px 24px 24px",
  },
  gridLine3: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 12px",
  },
};

const MdcInventoryDashboard = (props) => {
  const { classes, dispatch, language } = props;
  const [data, setData] = React.useState();
  const [filters, setFilters] = React.useState();

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: "dashboards",
          display: false,
        },
        {
          name: I18n.get("topbar_mdcInventoryDashboard"),
        },
      ])
    );
    console.log(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const search = async (filters) => {
    try {
      setData();

      let startDate = get(filters, ["startDate"]);
      let endDate = get(filters, ["endDate"]);
      if (get(filters, ["dateFilter"]) !== "custom") {
        [startDate, endDate] = computePeriod(get(filters, ["dateFilter"]));
      }

      let body = {
        zones: get(filters, ["zones"]),
        period: {
          start: new Date(startDate).toISOString(),
          end: new Date(endDate).toISOString(),
        },
        profiles_types: ["human", "vehicle", "trailer", "container"],
      };
      setFilters(body);
      let res = await fetchPost("api/v1/dac/drive-in-out", body);
      setData(res);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box className={classes.container}>
      <MdcInventoryForm search={search} language={language} />
      <MdcInventoryData data={data} />
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(MdcInventoryDashboard)
);
